module.exports = __webpack_public_path__ + "media/images/emblems/Thal-fa986ff2912cf584831b9b1f82b2aba0.png";